import * as React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { alpha, Badge, Box, IconButton, List, ListItem, ListItemButton, ListItemText, MenuItem, Popover, Select, Typography, useTheme } from '@mui/material';
import { Close, KeyboardArrowDown } from '@mui/icons-material';
import CircleIcon from '@mui/icons-material/Circle';
import parse from 'html-react-parser';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { useAuth } from '../../hooks/useAuth';
import { post } from '../../api';
import { relativeDates } from '../../utils/date';
import { format } from 'date-fns';
import { CustomChip } from '../../components/CustomChip';
import { CompanyBadge } from '../../components/CompanyBadge';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { useSelector } from 'react-redux';

const selectMailData = (state) => state.mail.data;

const NOTIFICATIONS_LIST = [
    {
        img: '/images/avatars/avatar_2.jpg',
        heading: '<b>Dianne Russell</b>  <span>marked the</span > <b>Good Bones</b>',
        createdAt: 'Sep 20, 2024, 1:30 PM',
        para: '~ New user registered',

        isNew: true,
        // isStatus: true,
        // status: 'In Progress',
    },
    {
        img: '/static/images/avatar/1.jpg',
        heading: '<b>Bessie Cooper</b>  <span> mentioned you in a activity<span/>',
        createdAt: 'Sep 20, 2024, 1:30 PM',
        para: '~ New user registered',

        isNew: true,
        // subHeading: '<b>@austin_sharma</b>  As discussed, Please review this task det...',
    },
    {
        img: '/static/images/avatar/1.jpg',
        heading: 'Kathryn Murphy',
        createdAt: 'Sep 20, 2024, 1:30 PM',
        para: '~ New user registered',
    },
    {
        img: '/images/avatars/avatar_2.jpg',
        heading: 'Payment Received! <span>paypal account number xxxx6754</span>',
        createdAt: 'Sep 20, 2024, 1:30 PM',
        para: '~ New user registered',
    },
    {
        img: '/static/images/avatar/1.jpg',
        heading: 'Airtel Pvt. Ltd. <span>requested a invoice change on #011101</span>',
        createdAt: 'Sep 20, 2024, 1:30 PM',
        para: '~ New user registered',

        // link: 'Review Billing History',
    },
];
export default function Notifications() {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const id = open ? 'notification-popover' : undefined;

    const [notifications, setNotifications] = React.useState([]);

    const data = useSelector(selectMailData);

    const theme = useTheme();

    const { getUserDetailsNotAsync, setUserDetailsNotAsync, refreshSessionData } = useAuth();
    const userDetails = getUserDetailsNotAsync();

    React.useEffect(() => {
        loadNotifications();
    }, []);

    React.useEffect(() => {
        const interval = setInterval(() => {
            loadNotifications();
        }, 30000); // 30 seconds

        return () => clearInterval(interval); // Cleanup when the component unmounts
    }, []);

    React.useEffect(() => {
        const records = data?.records && Array.isArray(data?.records) ? data.records : [];
        const recordsWhichReadInMails = [...records].filter((item) => item.read);

        const notReadNotifications = notifications.filter((item) => {
            if (recordsWhichReadInMails.find((cItem) => cItem.id === item.recordId && !item.isRead)) {
                return true;
            }
            return false;
        });

        if (!(notReadNotifications?.length > 0)) {
            return;
        }

        // ensure it runs after click on mail
        post('notification/read', { records: notReadNotifications }).then((result) => {
            if (result.isSuccess) {
                setNotifications(
                    notifications.map((item) => {
                        if (recordsWhichReadInMails.find((cItem) => cItem.id === item.recordId)) {
                            return { ...item, isRead: true };
                        }
                        return item;
                    })
                );
            }
        });
    }, [data?.records]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const loadNotifications = () => {
        post('notification/getRecords', { accountIds: userDetails.contact.relatedAccounts?.map((item) => item.accountId) }).then((result) => {
            if (result.isSuccess) {
                setNotifications(result.data.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate)));
            }
        });
    };

    const getSubject = (cListItem) => {
        if (cListItem.subject) {
            return parse(`${cListItem.subject}`);
        } else if (cListItem.type === 'Message From Prime' || cListItem.type === 'Navigate To My Company') {
            // return parse(`<b>${cListItem.createdByName === 'PRIME Relay Admin' ? 'PRIME Support' : cListItem.createdByName}</b>  <span>sent a message</span>`);
            return parse(`<b>PRIME Support</b>  <span>sent a message</span>`);
        }

        if (cListItem.type === 'Registered Agent Mail') {
            return parse(`<b>PRIME Registered Agent</b>  <span>sent a message</span>`);
        }
        return cListItem.type;
    };

    const navigateAndReload = (cListItem) => {
        if (cListItem.type === 'Message From Prime') {
            const event = new CustomEvent('navigateWithReload', {
                detail: { url: `/mail?filterId=2&mailId=${cListItem.recordId}` },
            });

            document.dispatchEvent(event);
        } else if (cListItem.type === 'Billing History') {
            const event = new CustomEvent('navigateWithReload', {
                detail: { url: `/payment-information/billing-history?filter=${cListItem.accountId}` },
            });

            document.dispatchEvent(event);
        } else if (cListItem.type === 'Payment Info Update') {
            const event = new CustomEvent('navigateWithReload', {
                detail: { url: `/payment-information/payment-methods` },
            });

            document.dispatchEvent(event);
        } else if (cListItem.type === 'Registered Agent Mail') {
            const event = new CustomEvent('navigateWithReload', {
                detail: { url: `/mail?filterId=1&mailId=${cListItem.recordId}&filter=${cListItem.accountId}` },
            });

            document.dispatchEvent(event);
        } else if (cListItem.type === 'Account Info Update') {
            const event = new CustomEvent('navigateWithReload', {
                detail: { url: `/account-info` },
            });

            document.dispatchEvent(event);
        } else if (cListItem.type === 'Service') {
            const event = new CustomEvent('navigateWithReload', {
                detail: { url: `/?filter=${cListItem.accountId}` },
            });

            document.dispatchEvent(event);
        } else if (cListItem.type === 'External Link') {
            if (cListItem.url) {
                window.open(cListItem.url, '_blank');
            }
        } else if (cListItem.type === 'Survey') {
            const event = new CustomEvent('navigateWithReload', {
                detail: { url: `/prime-assessment?surveyId=${cListItem.recordId}&contactId=${userDetails.contact.id}` },
            });

            document.dispatchEvent(event);
        } else if (cListItem.type === 'Navigate To My Company') {
            const event = new CustomEvent('navigateWithReload', {
                detail: { url: `/my-companies/${cListItem.recordId}` },
            });

            document.dispatchEvent(event);
        }
    };

    const notificationClick = (cListItem) => {
        const listWhichNotRead = notifications?.filter((item) => item.id === cListItem.id);

        if (listWhichNotRead?.length > 0) {
            if (listWhichNotRead?.[0]?.isRead) {
                navigateAndReload(cListItem);
            } else {
                post('notification/read', { records: listWhichNotRead }).then((result) => {
                    if (result.isSuccess) {
                        setNotifications(
                            notifications.map((item) => {
                                if (item.id === cListItem.id) {
                                    return { ...item, isRead: true };
                                }
                                return item;
                            })
                        );

                        navigateAndReload(cListItem);
                    }
                });
            }
        }

        handleClose();
    };

    const stripHtmlTags = (str) => {
        return str ? str.replace(/<[^>]*>/g, '') : '';
    };

    return (
        <React.Fragment>
            <Tooltip title="Notifications">
                <IconButton
                    title="Notifications"
                    onClick={handleClick}
                    sx={{
                        marginRight: 2,
                    }}
                >
                    <Badge
                        badgeContent={notifications?.filter((item) => !item.isRead).length}
                        color="error"
                        sx={{
                            '& .MuiBadge-badge': {
                                right: '-5px',
                                top: '0px',
                            },
                        }}
                    >
                        <NotificationsOutlinedIcon
                            width={24}
                            sx={{
                                color: theme.palette.brandSecondary[500],
                            }}
                        />
                    </Badge>
                </IconButton>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                sx={{
                    maxWidth: '500px',
                    '& .MuiPaper-root': {
                        overflow: 'visible',
                        minWidth: { xs: 'auto', md: '400px' },
                    },

                    '& .MuiPaper-root::before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        zIndex: 0,
                    },
                    '& .single-line': {
                        whiteSpace: 'wrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                    },
                }}
            >
                <Box padding={'10px 1rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                    <Typography color={'text.primary'} fontWeight={'fontWeightSemiBold'} fontSize="customFontSize.medium">
                        Notifications ({notifications?.length})
                    </Typography>

                    <IconButton onClick={handleClose} sx={{ marginLeft: '0.5rem', marginRight: '-0.5rem', padding: '6px' }}>
                        <Close fontSize="small" />
                    </IconButton>
                </Box>
                {/* <Divider /> */}

                <List sx={{ width: '100%', bgcolor: 'background.paper', padding: 0, margin: 0, marginBottom: '0.5rem', maxHeight: 500, overflow: 'auto' }}>
                    {notifications?.map((cListItem, index) => (
                        <ListItem
                            alignItems="flex-start"
                            sx={{
                                padding: '0',

                                '& .MuiButtonBase-root.MuiListItemButton-root': {
                                    borderTop: '0.5px solid #F3F3F3',
                                    padding: '4px 1rem',

                                    ...(!cListItem.isRead && {
                                        background: alpha('#1990FF', 0.08),
                                    }),
                                },

                                '&:last-child .MuiButtonBase-root.MuiListItemButton-root': {
                                    borderBottom: '0.5px solid #F3F3F3',
                                },
                            }}
                        >
                            <ListItemButton
                                alignItems="flex-start"
                                sx={{
                                    flexDirection: {
                                        xs: 'column',
                                        sm: 'row',
                                    },
                                }}
                                onClick={() => notificationClick(cListItem)}
                            >
                                <ListItemText
                                    primary={<Box className="single-line">{getSubject(cListItem)}</Box>}
                                    secondary={
                                        <React.Fragment>
                                            <Typography component={'p'} variant="paraText4" color={'text.secondary'}>
                                                {cListItem.type === 'Registered Agent Mail' ? (
                                                    <Box className="single-line">You’ve got mail! Click here to view.</Box>
                                                ) : (
                                                    <Box className="single-line">{stripHtmlTags(cListItem.body ? cListItem.body : cListItem.type === 'External Link' ? cListItem.url : '')}</Box>
                                                )}
                                            </Typography>
                                            {cListItem.link && (
                                                <Typography
                                                    fontWeight={'fontWeightMedium'}
                                                    fontSize={'customFontSize.small'}
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        padding: '4px 8px',
                                                        borderRadius: '4px',
                                                        background: '#0B150F08',
                                                        width: 'fit-content',
                                                    }}
                                                >
                                                    {cListItem.link}
                                                    <OpenInNewIcon sx={{ marginLeft: '0.5rem', fontSize: '1rem' }} />
                                                </Typography>
                                            )}
                                            <Box sx={{ marginTop: '15px', display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '1rem' }}>
                                                <CompanyBadge accountId={cListItem.accountId} accountName={cListItem.accountName} />
                                                <Typography sx={{}} color={'text.tertiary'} variant="body2" title={format(new Date(cListItem.createdDate), 'MM/dd/yyyy hh:mm a')}>
                                                    {relativeDates(cListItem.createdDate)}
                                                </Typography>
                                            </Box>
                                        </React.Fragment>
                                    }
                                    primaryTypographyProps={{
                                        variant: 'paraText2',
                                        color: 'text.primary',
                                        sx: {
                                            marginBottom: '0.5rem',
                                            '& span': {
                                                color: 'text.tertiary',
                                            },
                                        },
                                    }}
                                    sx={{
                                        marginRight: '2rem',
                                    }}
                                />

                                <Typography
                                    sx={{ wordBreak: 'keep-all', marginTop: '6px', marginBottom: '6px', color: alpha(theme.palette.text.secondary, 0.4) }}
                                    fontSize={'customFontSize.xSmall'}
                                    fontWeight={'fontWeightMedium'}
                                    display={'flex'}
                                    justifyContent={'center'}
                                    alignItems={'center'}
                                    flexDirection={{
                                        xs: 'row-reverse',
                                        sm: 'row',
                                    }}
                                >
                                    {cListItem.createdAt}

                                    {!cListItem.isRead && <CircleIcon sx={{ fill: '#1990FF', fontSize: '0.8rem', marginLeft: { xs: '0', sm: '0.5rem' }, marginRight: { xs: '0.5rem', sm: '0' } }} />}
                                </Typography>
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </Popover>
        </React.Fragment>
    );
}
